import { getUrlsTable } from '@repo/shared-config/constants/hosts';
import { getEnvironmentVariables } from '@repo/shared-config/helper/environment-variables';

// backendUrlsTable can be undefined at runtime when environment variables are not available
// (e.g., in unit tests without DOM/meta tags), even though TypeScript types say otherwise
const { backendUrlsTable } = getUrlsTable(getEnvironmentVariables());

// oxlint-disable-next-line typescript/no-unnecessary-condition -- runtime safety for test environments
export const apiBaseURL = backendUrlsTable?.apiBaseURL ?? '';
// oxlint-disable-next-line typescript/no-unnecessary-condition -- runtime safety for test environments
export const registerBaseURL = backendUrlsTable?.registerBaseURL ?? '';
// oxlint-disable-next-line typescript/no-unnecessary-condition -- runtime safety for test environments
export const registerPartnersBaseURL = backendUrlsTable?.registerPartnersBaseURL ?? '';
// oxlint-disable-next-line typescript/no-unnecessary-condition -- runtime safety for test environments
export const billerBaseURL = backendUrlsTable?.billerBaseURL ?? '';
// oxlint-disable-next-line typescript/no-unnecessary-condition -- runtime safety for test environments
export const authBaseURL = backendUrlsTable?.authBaseURL ?? '';
// oxlint-disable-next-line typescript/no-unnecessary-condition -- runtime safety for test environments
export const companyCreationBaseURL = backendUrlsTable?.companyCreationBaseURL ?? '';
